<template>
  <div>
    <div class="container">
      <div class="row mt-5">
        <div class="col-12 text-center my-5">
          <h3 class="heading">Initiatives</h3>
          <hr class="custom-hr">
        </div>
      </div>
      <div class="row">
        <div class="col-12 my-5">
          <flickity ref="flickity" :options="flickityOptions">
            <slot>
              <div class="carousel-cell demo">
                <div class="card">
                  <img class="card-img-top" src="../assets/images/blogimage/blog1.jpg" alt="Card image cap" style="350px;">
                  <div class="card-body">
                      <h2 class="card-title">Celebrating Earth Day at Rapsbun School of Nursing, Shillong</h2>
                      <!-- <h3 class="card-subtitle mb-2 text-muted">Card subtitle</h3> -->
                      <p class="card-text mt-4">#RoadToMetropolis Shillong Taking Up Art to celebrate Earth, Rapsbun School of Nursing, Shillong chose “Environment” as the theme for an Art Competition on the occasion of […]</p>
                      <a href="#"><span class="read-more">Read More >></span></a>
                  </div>
              </div>
              </div>
              <div class="carousel-cell demo">
                <div class="card">
                  <img class="card-img-top" src="../assets/images/blogimage/blog2.jpg" alt="Card image cap" style="350px;">
                  <div class="card-body">
                      <h2 class="card-title">Eco Trails: Throttling Towards A Greener Horizon</h2>
                      <!-- <h3 class="card-subtitle mb-2 text-muted">Card subtitle</h3> -->
                      <p class="card-text mt-4">Doing our bit for ‘Um – The Lifeline’ – Road to #Metropolis2018 #Shillong Street Art @ Laban Red Cross In Association with ARTH Art for Humanity […]</p>
                      <a href="#"><span class="read-more">Read More >></span></a>
                  </div>
              </div>
              </div>
            
              <div class="carousel-cell demo">
                <div class="card">
                  <img class="card-img-top" src="../assets/images/blogimage/6.jpg" alt="Card image cap" style="350px;">
                  <div class="card-body">
                      <h2 class="card-title">ARTYARD : Chapter II Verse In Motion</h2>
                      <!-- <h3 class="card-subtitle mb-2 text-muted">Card subtitle</h3> -->
                      <p class="card-text mt-4">#ARTYARD is an idea born out of isolation. It is a feeling to celebrate in confinement yet stay connected, a need to create space and to give Art its own address.</p>
                      <router-link to="/initiative/artyard"><span class="read-more">Read More >></span></router-link>
                  </div>
              </div>
              </div>
                <div class="carousel-cell demo">
                <div class="card">
                  <img class="card-img-top" src="../assets/images/blogimage/26.jpg" alt="Card image cap" style="350px;">
                  <div class="card-body">
                      <h2 class="card-title">Dream-A-Doodle</h2>
                      <!-- <h3 class="card-subtitle mb-2 text-muted">Card subtitle</h3> -->
                      <p class="card-text mt-4"> Give wings to your imagination and create a doodle story on “how you envision a compassionate world”.</p>
                      <router-link to="/initiative/doodle-a-dream"><span class="read-more">Read More >></span></router-link>
                  </div>
              </div>
              </div>
              <div class="carousel-cell demo">
                <div class="card">
                  <img class="card-img-top" src="../assets/images/blogimage/blog3.jpg" alt="Card image cap" style="350px;">
                  <div class="card-body">
                      <h2 class="card-title">GRAFFITI ART PROJECT</h2>
                      <!-- <h3 class="card-subtitle mb-2 text-muted">Card subtitle</h3> -->
                      <p class="card-text mt-4">Doing our bit for ‘Um – The Lifeline’ – Road to #Metropolis2018 #Shillong Street Art @ Laban Red Cross In Association with ARTH Art for Humanity […]</p>
                      <a href="#"><span class="read-more">Read More >></span></a>
                  </div>
              </div>
              </div>            
              <div class="carousel-cell demo">
                <div class="card">
                  <img class="card-img-top" src="../assets/images/blogimage/blog4.jpg" alt="Card image cap" style="350px;">
                  <div class="card-body">
                      <h2 class="card-title">2nd International Watercolour Society India</h2>
                      <!-- <h3 class="card-subtitle mb-2 text-muted">Card subtitle</h3> -->
                      <p class="card-text mt-4">and we began our journey with the celebration of colors !! #PrePromo #Metropolis2018 #NewDelhi An amalgamation of amazing artists from all across the globe @ […]</p>
                      <a href="#"><span class="read-more">Read More >></span></a>
                  </div>
              </div>
              </div>            
            </slot>
          </flickity>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Flickity from "vue-flickity"

export default {
  components: {
    Flickity
  },  
  props: {
    flickityOptions: {
      required: false,
      type: Object,
      default: () => ({        
        contain: true,  
        freeScroll : true,
        autoPlay: true      
      })
    }
  }
}
</script>

<style scoped>
  /* external css: flickity.css */



  .demo {
    height: 500px;
    width: 40%;
    /* margin-right: 20px;     */
    padding: 10px;
  }

  .demo img{
    width: 100%;
    height: 100%;
  }

  .card{
    height: 100%;
    -webkit-box-shadow:  0px 2px 8px lightgrey;box-shadow: 0px 2px 8px lightgrey;
    box-shadow: 0px 2px 8px lightgrey;
    width: 100%;
  }
  .card-img-top{
    height: 25.5rem !important;
    padding: 2px;
    /* clip-path: polygon(0% 0%, 100% 0, 100% 90%, 48% 100%, 0 91%); */
    clip-path: polygon(0 0, 100% 0%, 100% 87%, 0 98%);
    object-fit: cover;
    object-position: center;
  }
  .card-img-top img{
    height: 100%;
  }
  .card-body{
    font-size: 1.4rem;
    padding: 2rem;
    margin-top: -15px;
  }

  .card-title{
    font-size: var(--card-font);
    font-weight: 700;
  }

  .btn{
    /* border-radius: 100px; */
    padding: 8px 14px;
    padding-right: 18px;
    font-size: 1.6rem;
    clip-path: polygon(0 0, 89% 0, 90% 0, 100% 50%, 89% 100%, 89% 100%, 0 100%);
  }

  .btn-primary{
    background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;
    border: #00f2fe;
  }

  @media (max-width: 700px){
    .demo{
      width: 100%;
    }
    .card-title{
      font-size: var(--card-font-mobile);
    }
    .card-text  {
    font-size: var(--default-font-mobile);
    }
  }
</style>
